import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import MaskedInput from 'react-text-mask';
export const PercentInputComponent = ({ field, form, id, initialValue, listName, testId, }) => {
    const [percent, setPercent] = useState(`${initialValue}`);
    const handleBlur = () => {
        if (form && field && field.name && listName) {
            const { setFieldTouched, setFieldValue, values } = form;
            const { name } = field;
            // Ensure values is an array and listName exists in it
            if (values && Array.isArray(values[listName])) {
                const fieldPercent = parseInt(percent, 10);
                const totalPercent = values[listName].reduce((total, bene) => {
                    let originalPercent = bene.percent;
                    if (bene.id === id) {
                        originalPercent = fieldPercent;
                    }
                    return total + originalPercent;
                }, 0);
                // Use optional chaining to safely call these methods
                setFieldValue?.(name, fieldPercent);
                setFieldValue?.(`${listName}Percent`, totalPercent);
                setFieldTouched?.(name, true);
            }
        }
    };
    const handleChange = (e) => {
        setPercent(e.target.value || '0');
    };
    const numberMask = createNumberMask({
        suffix: '%',
        prefix: '',
        includeThousandsSeparator: false,
    });
    return (_jsx(MaskedInput, { className: "percentage-input", "data-testid": testId, mask: numberMask, id: id, type: "text", onChange: handleChange, onBlur: handleBlur, value: percent }));
};
export default PercentInputComponent;
//# sourceMappingURL=percent-input.js.map